import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-primary absolute -top-1 -right-1 flex size-4 items-center justify-center rounded-full text-[10px] leading-none text-white"
}
const _hoisted_2 = { class: "flex items-center justify-between px-2" }
const _hoisted_3 = { class: "text-sm font-medium" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = {
  key: 0,
  class: "bg-primary size-1 rounded-full"
}

import type { Table } from '@tanstack/vue-table';
    import { computed, watch } from 'vue';
    import {
        Accordion,
        AccordionContent,
        AccordionItem,
        AccordionTrigger,
    } from '@/components/ui/accordion';
    import { Button } from '@/components/ui/button';
    import { PopoverRoot, PopoverContent, PopoverTrigger } from 'reka-ui';
    import { Funnel } from 'lucide-vue-next';
    import { useI18n } from 'vue-i18n';
    import ColumnFilter from '@/components/filters/ColumnFilter.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableFilters',
  props: {
    table: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const columns = computed(() =>
        props.table
            .getAllLeafColumns()
            .filter((column) => typeof column.accessorFn !== 'undefined' && column.getCanFilter()),
    );

    const filterCount = computed(() => {
        return props.table.getState().columnFilters.length;
    });

    const getColumnTitle = (column: any) => {
        const headerContext = { column };
        try {
            const headerContent = column.columnDef.header(headerContext);
            return headerContent?.props?.title || column.id;
        } catch (error) {
            console.error('Filterable column without header:', column.id);
            return column.id;
        }
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PopoverRoot), null, {
    default: _withCtx(() => [
      _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "outline",
            size: "xs",
            class: "relative"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Funnel)),
              _createVNode(_Transition, { name: "fade-scale" }, {
                default: _withCtx(() => [
                  (filterCount.value > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(filterCount.value), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(PopoverContent), {
        align: "end",
        class: "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--reka-popover-content-available-height) min-w-xs origin-(--reka-popover-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md",
        sideOffset: 4
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('tables.filters.filters')), 1),
            _createVNode(_unref(Button), {
              variant: "link_destructive",
              size: "xs",
              width: "narrow",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.table.resetColumnFilters()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('tables.reset')), 1)
              ]),
              _: 1
            })
          ]),
          _createVNode(_unref(Accordion), {
            type: "single",
            collapsible: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns.value, (column) => {
                return (_openBlock(), _createBlock(_unref(AccordionItem), {
                  key: column.id,
                  value: column.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AccordionTrigger), null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createTextVNode(_toDisplayString(_unref(t)(getColumnTitle(column))) + " ", 1),
                          (column.getFilterValue())
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(AccordionContent), { class: "p-2" }, {
                      default: _withCtx(() => [
                        _createVNode(ColumnFilter, {
                          column: column,
                          table: _ctx.table
                        }, null, 8, ["column", "table"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})